<template>
  <q-page padding>
    <PageHeader
      title="Listagem de Pins e Trocas"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />
    <table-pins />
  </q-page>
</template>

<script>
import TablePins from "../components/TablePins.vue";
import PageHeader from "../../../../components/PageHeader.vue";
export default {
  components: { TablePins, PageHeader },
  setup() {
    return {};
  },
};
</script>
